import { call, type ForkEffect, put, takeLatest } from 'redux-saga/effects';

import * as licenseService from '../services/licensesApiService';

import { type SearchResult } from '../../../@types/serviceTypes';

import { toasterValidationError } from '../../../helpers';
import type { ILicenseSearchResult } from './types';
import * as slicesActions from './slices';
import * as actions from './actions';

function* getNewLicenses(action: ReturnType<typeof actions.getLicenses>) {
  const {
    payload: { page, sortByFields, restrictions, excludedStatuses, selectFields, licenseTypeNature },
  } = action;

  try {
    yield put(slicesActions.setNewLicensesLoading({ loading: true, licenseTypeNature }));

    const { data } = yield call(licenseService.getLicenses, {
      page,
      sortByFields,
      restrictions,
      excludedStatuses,
      selectFields,
      licenseTypeNature,
    });

    yield put(
      slicesActions.setNewLicenses({ searchResult: data as SearchResult<ILicenseSearchResult>, licenseTypeNature })
    );
  } catch (err) {
    yield put(slicesActions.resetNewLicensesData({ licenseTypeNature }));
    toasterValidationError(err);
    console.error(err);
  } finally {
    yield put(slicesActions.setNewLicensesLoading({ loading: false, licenseTypeNature }));
  }
}

function* getLicenses(action: ReturnType<typeof actions.getLicenses>) {
  const {
    payload: { page, sortByFields, restrictions, excludedStatuses, selectFields, licenseTypeNature },
  } = action;

  try {
    yield put(slicesActions.setLicensesLoading({ loading: true, licenseTypeNature }));
    const { data } = yield call(licenseService.getLicenses, {
      page,
      sortByFields,
      restrictions,
      excludedStatuses,
      selectFields,
      licenseTypeNature,
    });

    yield put(
      slicesActions.setLicenses({ searchResult: data as SearchResult<ILicenseSearchResult>, licenseTypeNature })
    );
  } catch (err) {
    yield put(slicesActions.resetLicensesData({ licenseTypeNature }));
    toasterValidationError(err);
    console.error(err);
  } finally {
    yield put(slicesActions.setLicensesLoading({ loading: false, licenseTypeNature }));
  }
}

export function* watchLicensesSaga(): Generator<ForkEffect> {
  yield takeLatest(actions.getNewLicenses.type, getNewLicenses);
  yield takeLatest(actions.getLicenses.type, getLicenses);
}
